module.exports = __webpack_public_path__ + "android-chrome-512x512.b1d733c1.png";